import styles from './how-block.module.scss';
import { page } from 'src/locale';
// import { useStore } from 'src/stores';
/**
 * <HowBlock />
 */

const HowBlock = () => {
  // const {
  //   formStore: { locale }
  // } = useStore();

  const locale = 'ua';
  return (
    <div className={styles.how}>
      <div className={styles.container}>
        <h2 className={styles.title}>{page.block.title[locale]}</h2>
        <ul className={styles.list}>
          {page.block.list.map((el: any, index: number) => (
            <li
              key={index}
              className={styles.item}
              style={{ backgroundImage: `url(${el.icon})` }}
            >
              {el.text[locale]}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export { HowBlock };
